import React, {useEffect, useState} from 'react';
import {Layout, Menu} from "antd";
import MenuItem from "../../components/Common/MenuItem";
import {AuditOutlined, DashboardOutlined, UserOutlined,} from "@ant-design/icons";
import {useLocation, useNavigate} from "react-router-dom";
import UserProfile from "./UserProfile";

const AppSider = () => {
    const { Sider } = Layout;
    const navigate = useNavigate();
    const location = useLocation().pathname;
    const [selectKey, setSelectKey] = useState('/manager/list');

    useEffect(() => {
        setSelectKey(location);
    }, [location]);

    const onClickMain = () => {
        navigate('/manager/list');
    }

    const onClickMenu = (e) => {
        navigate(e.key);
    }

    const menuItems = [
        MenuItem('DashBoard', '/dashboard', <DashboardOutlined />),
        MenuItem('실무자 관리', '/manager', <UserOutlined />,
            [MenuItem('사용자 목록', '/manager/list'), MenuItem('사용자 기록', '/manager/audit')]),
        MenuItem('의뢰자 관리', '/customer', <UserOutlined />,
            [MenuItem('사용자 목록', '/customer/list'), MenuItem('사용자 기록', '/customer/audit')]),
        MenuItem('시스템 기록 추적', '/audit', <AuditOutlined />),
        // MenuItem('케이스 데이터 다운로드', '/down', <DownloadOutlined />),
    ]

    return (
        <Sider style={{backgroundColor: 'rgb(220, 220, 220)'}}>
            <div style={{cursor: 'pointer', height: 64, width: '100%', textAlign: 'center', backgroundColor: '#ffffff'}} onClick={onClickMain}>
                <img alt='logo' src='/images/asan_logo.png' style={{maxWidth: '100%', maxHeight: '100%', padding: '0.5rem'}}/>
            </div>
            <UserProfile />
            <Menu mode='inline' selectedKeys={[selectKey]} onClick={onClickMenu} items={menuItems} defaultOpenKeys={['/manager', '/customer']}
                  style={{backgroundColor: 'rgb(220, 220, 220)', borderInlineEnd: 'none'}}/>
        </Sider>
    );
};

export default AppSider;